<template>
  <scout-form
    :is-modified="isModified"
    label="会員登録時期の指定"
  >
    <term-select
      :selected-option="selectedOption"
      :from="from"
      :to="to"
      date-label="会員登録日"
      @update:selectedOption="$emit('update:selectedOption', $event)"
      @update:from="$emit('update:from', $event)"
      @update:to="$emit('update:to', $event)"
    />
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import TermSelect from '@/components/atoms/TermSelect'

export default {
  components: {
    ScoutForm,
    TermSelect
  },
  props: {
    from: {
      required: true,
      type: String
    },
    selectedOption: {
      default: () => { return { terms: 'select' } },
      type: Object
    },
    to: {
      required: true,
      type: String
    }
  },
  computed: {
    isModified () {
      return !!this.from && !!this.to
    }
  }
}
</script>
